/*
 * Generated from Times-Roman.afm. Do not edit directly.
 * The source AFM metrics were converted to JavaScript; this is a modification.
 * Copyright (c) 1985, 1987, 1989, 1990, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.Times is a trademark of Linotype-Hell AG and/or its subsidiaries.
 *
 * This file and the 14 PostScript(R) AFM files it accompanies may be used, copied, and distributed for any purpose and without charge, with or without modification, provided that all copyright notices are retained; that the AFM files are not distributed without this file; that all modifications to this file or any of the AFM files are prominently noted in the modified file(s); and that this paragraph is not modified. Adobe Systems has no responsibility or obligation to support the use of the AFM files.
 */
import glyphNames from './standardGlyphNames.js';
export default {
  name: 'Times-Roman',
  bbox: [-168, -218, 1000, 898],
  ascender: 683,
  descender: -217,
  xHeight: 450,
  capHeight: 662,
  glyphNames,
  glyphWidths: [
    250, 333, 408, 500, 500, 833, 778, 180, 333, 333, 500, 564, 250, 333, 250,
    278, 500, 500, 500, 500, 500, 500, 500, 500, 500, 500, 278, 278, 564, 564,
    564, 444, 921, 722, 667, 667, 722, 611, 556, 722, 722, 333, 389, 722, 611,
    889, 722, 722, 556, 722, 667, 556, 611, 722, 722, 944, 722, 722, 611, 333,
    278, 333, 469, 500, 333, 444, 500, 444, 500, 444, 333, 500, 500, 278, 278,
    500, 278, 778, 500, 500, 500, 500, 333, 389, 278, 500, 500, 722, 500, 500,
    444, 480, 200, 480, 541, 500, 333, 500, 444, 1000, 500, 500, 333, 1000, 556,
    333, 889, 611, 333, 333, 444, 444, 350, 500, 1000, 333, 980, 389, 333, 722,
    444, 500, 333, 500, 500, 500, 500, 200, 500, 333, 760, 276, 500, 564, 760,
    333, 400, 564, 300, 300, 333, 500, 453, 250, 333, 300, 310, 500, 750, 750,
    750, 444, 722, 722, 722, 722, 722, 722, 889, 667, 611, 611, 611, 611, 333,
    333, 333, 333, 722, 722, 722, 722, 722, 722, 722, 564, 722, 722, 722, 722,
    722, 722, 556, 500, 444, 444, 444, 444, 444, 444, 667, 444, 444, 444, 444,
    444, 278, 278, 278, 278, 500, 500, 500, 500, 500, 500, 500, 564, 500, 500,
    500, 500, 500, 500, 500,
  ],
  kernPairs: [
    -135,
    [7149, 4494, 119, 1, 1, 1, 1, 1, 20967, 215, 215, 215, 215, 215],
    -129,
    [11622, 2, 65, 124, 1, 4, 449, 2, 26658, 2],
    -120,
    [
      11858, 119, 1, 1, 1, 1, 1, 306, 119, 1, 1, 1, 1, 1, 26536, 119, 1, 1, 1,
      1, 1,
    ],
    -111,
    [
      7147, 57, 3128, 2, 1341, 4, 116, 4, 4, 465, 72, 125, 1, 20266, 57, 158,
      57, 158, 57, 158, 57, 158, 57, 158, 57, 5064, 72, 125, 1,
    ],
    -110,
    [12334, 124, 1, 4, 26531, 124, 1, 4],
    -105,
    [7152, 124, 25461, 124, 91, 124, 91, 124, 91, 124, 91, 124, 91, 124],
    -100,
    [9514, 3, 124, 1982, 697, 4, 116, 1, 3, 4, 1, 26531, 4, 116, 1, 3, 4, 1],
    -93,
    [11213, 119, 1, 1, 1, 1, 1],
    -92,
    [
      7182, 2, 32, 92, 2204, 57, 784, 119, 1, 1, 1, 1, 1, 716, 644, 2, 442, 1,
      20485, 2, 32, 92, 89, 2, 32, 92, 89, 2, 32, 92, 89, 2, 32, 92, 89, 2, 32,
      92, 89, 2, 32, 92, 4973, 1,
    ],
    -90,
    [57, 124, 6969, 25585, 215, 215, 215, 215, 215],
    -89,
    [11812, 3, 1],
    -80,
    [
      8182, 2, 2620, 441, 14, 8, 2, 32, 64, 1, 3, 13, 1, 1, 1, 1, 2, 5, 497, 4,
      10, 105, 1, 1, 1, 1, 1, 4, 1, 8, 1, 1, 1, 1, 2, 11220, 119, 1, 1, 1, 1, 1,
      306, 119, 1, 1, 1, 1, 1,
    ],
    -75,
    [11695, 124, 1, 1, 1],
    -74,
    [
      7181, 1022, 119, 1, 1, 1, 1, 1, 1188, 1677, 2, 442, 1, 11691, 107, 109,
      9222, 215, 215, 215, 215, 215,
    ],
    -73,
    [11914, 32, 92],
    -71,
    [11794, 2, 1, 1, 4, 2, 1, 659, 3, 26657, 3],
    -70,
    [2689, 2, 428, 2, 8128, 123, 1, 1, 1083, 3, 1, 26656, 3, 1],
    -65,
    [10807, 124, 907, 6664, 2, 213, 2, 428, 2, 6878, 2, 19778, 2],
    -60,
    [
      9063, 119, 1, 1, 1, 1, 1, 1615, 881, 124, 632, 3, 1, 4, 3, 26649, 3, 1, 4,
      3,
    ],
    -55,
    [
      33, 119, 1, 1, 1, 1, 1, 6985, 2, 4, 117, 1, 1, 1, 1, 2, 1, 1, 1, 1, 522,
      124, 1628, 32, 92, 1132, 402, 1121, 124, 5192, 5874, 34, 9175, 2, 4, 117,
      1, 1, 1, 1, 2, 1, 1, 1, 1, 82, 2, 4, 117, 1, 1, 1, 1, 2, 1, 1, 1, 1, 82,
      2, 4, 117, 1, 1, 1, 1, 2, 1, 1, 1, 1, 82, 2, 4, 117, 1, 1, 1, 1, 2, 1, 1,
      1, 1, 82, 2, 4, 117, 1, 1, 1, 1, 2, 1, 1, 1, 1, 82, 2, 4, 117, 1, 1, 1, 1,
      2, 1, 1, 1, 1, 5053, 124,
    ],
    -50,
    [
      54, 10105, 3, 124, 920, 704, 124, 1, 1, 1, 11466, 14, 4, 13083, 3, 124,
      88, 3, 124, 88, 3, 124, 88, 3, 124, 88, 3, 124, 303, 3, 124,
    ],
    -45,
    [11265, 124, 1, 1, 1],
    -40,
    [
      7130, 4, 120, 519, 21, 98, 1, 1, 1, 1, 1, 2260, 4, 636, 6, 117, 1, 1, 1,
      1, 2, 1, 1, 1, 1, 434, 3, 1, 60, 119, 1, 1, 1, 1, 1, 105, 123, 1, 1, 1, 1,
      2, 112, 119, 3, 2, 2182, 2652, 786, 15073, 4, 120, 91, 4, 120, 91, 4, 120,
      91, 4, 120, 91, 4, 120, 91, 4, 120, 2688, 4, 211, 4, 211, 4, 211, 4, 211,
      4, 426, 4, 192, 119, 1, 1, 1, 1, 1, 91, 119, 1, 1, 1, 1, 1, 91, 119, 1, 1,
      1, 1, 1, 91, 119, 1, 1, 1, 1, 1, 4444,
    ],
    -37,
    [11851, 1],
    -35,
    [
      7343, 119, 1, 1, 1, 1, 1, 1857, 123, 1, 1, 1, 1, 2, 470, 119, 1, 1, 1, 1,
      1, 91, 22, 97, 1, 1, 1, 1, 1, 991, 9, 115, 24991, 119, 1, 1, 1, 1, 1, 91,
      22, 97, 1, 1, 1, 1, 1, 91, 22, 97, 1, 1, 1, 1, 1, 91, 22, 97, 1, 1, 1, 1,
      1, 91, 22, 97, 1, 1, 1, 1, 1, 91, 22, 97, 1, 1, 1, 1, 1, 306, 22, 97, 1,
      1, 1, 1, 1,
    ],
    -30,
    [
      55, 7740, 1497, 123, 1, 1, 1, 1, 2, 1954, 927, 123, 1, 1, 1, 1, 2, 26531,
      123, 1, 1, 1, 1, 2,
    ],
    -25,
    [
      9314, 20, 32, 71, 1, 1, 1, 18, 5463, 1, 198, 661, 1291, 1483, 119, 1, 1,
      1, 1, 1, 22687, 1, 214, 1, 214, 1, 214, 1, 214, 215, 215, 215, 646, 215,
      215, 215, 215, 430,
    ],
    -20,
    [
      11806, 2, 1, 2252, 214, 124, 1, 1, 1, 721, 124, 2396, 926, 123, 1, 1, 1,
      1, 2, 20948, 215, 215, 215, 215, 215,
    ],
    -18,
    [52, 11175, 123, 1, 1, 1, 1, 2, 6345, 5818],
    -15,
    [
      8235, 14, 105, 1, 1, 1, 1, 1, 13, 1, 1, 1, 1, 2, 952, 124, 1, 1, 1, 928,
      119, 1, 1, 1, 1, 1, 1140, 2413, 214, 218, 32, 92, 288, 17, 1, 32, 92,
      1166, 32, 92, 521, 32, 92, 88, 1488, 123, 1, 1, 1, 304, 123, 1, 1, 1,
      20532, 215, 215, 215, 215, 215, 432, 32, 92, 73, 17, 1, 32, 92, 73, 17, 1,
      32, 92, 73, 17, 1, 32, 92, 73, 17, 1, 32, 92, 1166, 32, 92, 88, 215, 215,
      215, 215, 430,
    ],
    -10,
    [
      7363, 124, 1, 1, 1, 3098, 124, 1, 1, 1, 1157, 123, 1, 1, 1, 1, 2, 3114,
      119, 1, 1, 1, 1, 1, 955, 10, 113, 1, 1, 1, 7, 1, 1, 1, 1, 2, 94, 647, 32,
      92, 91, 32, 92, 1357, 14, 105, 1, 1, 1, 1, 1, 13, 1, 1, 1, 1, 2, 4598,
      20008, 32, 92, 91, 32, 92, 91, 32, 92, 91, 32, 92, 91, 32, 92, 306, 32,
      92,
    ],
    -5,
    [15330, 119, 1, 1, 1, 1, 1, 115, 32, 92],
    55,
    [15159],
  ],
};
